import { useTranslation } from '@dagens/frontend-i18n';
import { useMediaQuery } from '../../hooks/useMediaQueries';
import Typography from '@carrot-deprecated/typography';
import { formatNok } from 'utils/texts';

type OrderLineTableFooterProps = {
  isReadOnly?: boolean;
  originalTotalPrice: number;
  totalPrice: number;
};

const OrderLineTableFooter = ({
  isReadOnly,
  originalTotalPrice,
  totalPrice
}: OrderLineTableFooterProps) => {
  const { t } = useTranslation();
  const { mobileOnly } = useMediaQuery();

  return (
    <tfoot>
      <tr>
        <td className={mobileOnly ? 'col-span-2' : 'col-span-3'}>
          <Typography variant="paragraphBold">
            {t('common:Sum')}
            &nbsp;
            {t('common:exVatAndTransport')}
          </Typography>
        </td>
        <td className="!text-right">
          <Typography variant="paragraphBold">
            {formatNok(totalPrice)}
          </Typography>
          {totalPrice !== originalTotalPrice && (
            <Typography
              variant="paragraphSmall"
              color="secondary"
              style={{ whiteSpace: 'nowrap', textDecoration: 'line-through' }}
            >
              {formatNok(originalTotalPrice)}
            </Typography>
          )}
        </td>
        {!isReadOnly && <td></td>}
      </tr>
    </tfoot>
  );
};

export default OrderLineTableFooter;
